import React from 'react'
import LabelField from './fields/LabelField'

const TableRowOtherSetting = ({htmlFor, label, children}) => {
  return (
    <tr className="dreamfox-table-other__row">
      <td className="dreamfox-table-other__label">
        <LabelField htmlFor={'dreamfox-field-'+htmlFor}>{label}</LabelField>
      </td>
      <td className="dreamfox-table-other__content">
        {children}
      </td>
    </tr>
  )
}

export default TableRowOtherSetting
